import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import { FixedbottomButtonCover } from "../../../common";
import primaryComponents from "../../../primaryComponents";
import { AdditionalDetailsForm } from "./AdditionalDetailsForm";
import { BasicInfo } from "./BasicInfo";
import { PriceSummary } from "./PriceSummary";
import { ProductSelection } from "./ProductSelection";
import styles from "./styles.module.scss";
import { usePurchaseOrderForm } from "./usePurchaseOrderForm";
import { useValidation } from "./useValidation";

export const PurchaseOrderForm = ({
  isEditMode = false,
  PODetails = {},
  POItems = [],
}) => {
  const { pOForm, isSubmittingPO, setPOForm, createOrUpdatePO } =
    usePurchaseOrderForm({ isEditMode, PODetails, POItems });
  const { handleSubmit, ...validationParams } = useValidation({ ...pOForm });

  const hasValidItems =
    Array.isArray(pOForm?.items) &&
    pOForm.items.length > 0 &&
    pOForm.items.every(
      (item) =>
        item?.requested_quantity !== "" &&
        item?.requested_quantity !== null &&
        item?.requested_quantity !== undefined &&
        Number(item?.requested_quantity) > 0 &&
        item?.cost_price !== "" &&
        item?.cost_price !== null &&
        item?.cost_price !== undefined &&
        Number(item?.cost_price) >= 0,
    );

  const isSubmitDisabled =
    isSubmittingPO ||
    !pOForm?.supplier_id ||
    !pOForm?.category_id ||
    !pOForm?.po_date ||
    !hasValidItems;

  const isDraftDisabled =
    isSubmittingPO ||
    !pOForm?.supplier_id ||
    !pOForm?.items ||
    pOForm?.items?.length === 0;

  const handleSaveAsDraft = () => {
    if (isDraftDisabled) return;
    createOrUpdatePO("DRAFT");
  };

  return (
    <form
      className={`${globalStyles.pageColumnGaps} ${styles.purchaseOrderForm}`}
      onSubmit={handleSubmit(() => createOrUpdatePO("IN_REVIEW"))}
    >
      <div className={styles.formTop}>
        <BasicInfo
          {...validationParams}
          PODetails={PODetails}
          pOForm={pOForm}
          setPOForm={setPOForm}
        />
        <ProductSelection
          {...validationParams}
          pOForm={pOForm}
          setPOForm={setPOForm}
        />
      </div>

      <PriceSummary {...validationParams} pOForm={pOForm} />

      <AdditionalDetailsForm
        {...validationParams}
        pOForm={pOForm}
        setPOForm={setPOForm}
      />

      <FixedbottomButtonCover>
        <primaryComponents.Button
          classNames={"btn btn--outline"}
          style={{ width: "200px" }}
          type="button"
          isDisabled={isDraftDisabled}
          isLoading={isSubmittingPO}
          loadingText={"Saving as draft..."}
          onClick={handleSaveAsDraft}
        >
          Save As Draft
        </primaryComponents.Button>

        <primaryComponents.Button
          classNames={"btn btn--primary ml-auto"}
          style={{ width: "200px" }}
          type="submit"
          isDisabled={isSubmitDisabled}
          isLoading={isSubmittingPO}
          loadingText={isEditMode ? "Updating PO..." : "Creating PO..."}
        >
          {isEditMode ? "Update PO" : "Create PO"}
        </primaryComponents.Button>
      </FixedbottomButtonCover>
    </form>
  );
};
